import React, {useState} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {Formik} from 'formik';
import ButtonAction from '../../../_common/components/ButtonAction';
import classnames from 'classnames';
import CompleteInspectionPage from '../../../CompleteInspectionPage';
import FieldTextareaAutosize from '../../../_common/components/FieldTextareaAutosize';
import ModalContainer from '../../../_common/components/ModalContainer';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';
import ModalContent from '../../../_common/components/ModalContent';
import {can} from '../../../_common/components/Permissions';
import * as actions from '../../_redux/actions/shumaActions';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {permissionTypes as T, subjects as S} from '../../../_common/constants/permissionSubjects';
import {shumaStatusTypeIds as STATUS} from '../../../_common/constants/shumaStatusTypeIds';
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../_common/styles/styles';
import styles from '../../styles/styles.module.scss';

const PopupFinalPDFData = ({content}) => {
  const dispatch = useDispatch();
  const [rejectReason, setRejectReason] = useState(false);
  const {adminPermissionsLevel} = useSelector(
    (state) => ({adminPermissionsLevel: state.auth.adminPermissionsLevel}), shallowEqual
  );

  const approveShumaFunc = (shumaID) => {
    if (adminPermissionsLevel === 1) {
      dispatch(actions.approveShumaAndRequestSignature({shumaID}));
    }
    if (adminPermissionsLevel === 2) {
      dispatch(actions.approveShuma({shumaID}));
    }
  };
  const rejectShumaFunc = (shumaID, rejectText) => {
    dispatch(actions.rejectShuma({shumaID, rejectText}));
  };

  const handleApprove = (close) => {
    approveShumaFunc(content.shumaID);
    close();
    setRejectReason(false);
  };
  const handleReject = (close, value) => {
    rejectShumaFunc(content.shumaID, value);
    close();
    setRejectReason(false);
  };

  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);

  const disabledCondition = !can(T.FULL, S.INSPECTIONS_PAGE)
    || content?.originTypeID === 3
    || adminPermissionsLevel === 3
    || Boolean(!adminPermissionsLevel);
  const showApproveRejectButtons = !(
    content?.shumaStatusTypeID === STATUS.IN_PROGRESS ||
    content?.shumaStatusTypeID === STATUS.COMPLETED ||
    content?.shumaStatusTypeID === STATUS.COMPLETED_MANUALLY ||
    (content?.shumaStatusTypeID === STATUS.PENDING_SIGNATURE && adminPermissionsLevel === 1)
  );

  return (
    <>
      <ButtonAction
        iconButtonType={'error'}
        variant={'icon'}
        label={<img src={toAbsoluteUrl('media/common/Zoom-plus_red.svg')} alt={'icon'} className="w-20px h-20px"/>}
        title={TTS.PREVIEW_SHUMA}
        onClick={() => handleShowModal()}
        disabled={disabledCondition}
        customClassnames={'my-1'}
      />
      <ModalContainer show={show} onHide={handleCloseModal} size={'xl'}>
        <ModalContent customClassnames={styles.contentContainer}>
          <div className={styles.documentViewPort}>
            <div className={classnames(styles.iframeContainerWrapper, styles.whiteBg)}>
              <div className={styles.iframeContainer}>
                <CompleteInspectionPage
                  cellContent={{
                    ...content,
                    closeModal: handleCloseModal
                  }}
                />
              </div>
            </div>
          </div>
        </ModalContent>
        <ModalButtonsContainer customClassnames={largeButtonsPadding}>
          <Formik
            initialValues={{rejectReasonText: ''}}
            onSubmit={() => {}}
            enableReinitialize={true}
          >
            {({values}) => (
              <form className={'w-100'}>
                {!rejectReason && (
                  <div className={'d-flex align-items-center justify-content-center'}>
                    <ButtonAction
                      variant={'cancel'}
                      label={'סגירה'}
                      onClick={handleCloseModal}
                      customClassnames={buttonCancel}
                    />
                    {showApproveRejectButtons && (
                      <>
                        <ButtonAction
                          label={'אישור'}
                          useIcon={'/media/common/Check-in-circle_white.svg'}
                          onClick={() => handleApprove(handleCloseModal)}
                          customClassnames={buttonSubmit}
                        />
                        <ButtonAction
                          variant={'error'}
                          label={'דחייה'}
                          useIcon={'/media/common/Cross_circle_white.svg'}
                          onClick={() => setRejectReason(true)}
                          customClassnames={buttonSubmit}
                        />
                      </>
                    )}
                  </div>
                )}
                {rejectReason && (
                  <div className={'w-100 d-flex align-items-center justify-content-center'}>
                    <FieldTextareaAutosize
                      fieldId="rejectReasonText"
                      value={values.rejectReasonText}
                      placeholder="reason"
                      customContainerStyles={'w-100 mx-2'}
                    />
                    <ButtonAction
                      variant={'cancel'}
                      label={'ביטול'}
                      onClick={() => setRejectReason(false)}
                      customClassnames={buttonCancel}
                    />
                    <ButtonAction
                      useIcon={'/media/common/Check-in-circle_white.svg'}
                      label={'שליחה'}
                      onClick={() => handleReject(handleCloseModal, values.rejectReasonText)}
                      customClassnames={buttonSubmit}
                    />
                  </div>
                )}
              </form>
            )}
          </Formik>
        </ModalButtonsContainer>
      </ModalContainer>
    </>
  );
};

export default PopupFinalPDFData;